export const ServiceSubtypes = {
  BASE_REMOTE_CONTROL: 'base_remote_control',
  DATA_MANAGER: 'data_manager',
  DISCOVERY: 'discovery',
  GENERIC: 'generic',
  ML_MODEL: 'mlmodel',
  MOTION: 'motion',
  NAVIGATION: 'navigation',
  SENSORS: 'sensors',
  SHELL: 'shell',
  SLAM: 'slam',
  VISION: 'vision',
} as const;

export type ServiceSubtype =
  (typeof ServiceSubtypes)[keyof typeof ServiceSubtypes];

const serviceSubtypeValues: ReadonlySet<string> = new Set(
  Object.values(ServiceSubtypes)
);

export const isServiceSubtype = (name: string): name is ServiceSubtype => {
  return serviceSubtypeValues.has(name);
};
